<div class="container login-block">
  <div class="row row-mar-30">
    <div class="col-sm-4 width-sm-100 padding-lg-rit-22">
      <div
        data-se="auth-container"
        id="okta-sign-in"
        class="auth-container main-container no-beacon"
      >
        <div class="okta-sign-in-header auth-header">
          <img
            src="//logo.clearbit.com/okta.com"
            class="auth-org-logo"
            alt=""
          />
          <div data-type="beacon-container" class="beacon-container"></div>
        </div>
        <div class="auth-content">
          <div class="auth-content-inner">
            <ng-container *ngTemplateOutlet="MFA_Authentication"></ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-8 width-sm-100 callout-item" *ngIf="isDataAvailable">
      <div class="">
        <h2>{{ loginData.data[0].heading }}</h2>
        <p>{{ loginData.data[0].description }}</p>
        <ul class="dashed">
          <li *ngFor="let item of loginData.data[0].displayItems">
            {{ item.description }}
          </li>
        </ul>
      </div>
      <div>
        <p [innerHTML]="loginData.data[0].text"></p>
      </div>
    </div>
  </div>
</div>
<!--Media Block-->
<div class="media-content">
  <div class="container" id="custom-container" *ngIf="isDataAvailable">
    <div class="row">
      <div class="col-sm-12 col-md-5 media-text">
        <p>
          {{ loginData.media[0].description }}
        </p>
      </div>
      <div class="col-sm-12 col-md-7 spacing">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            class="embed-responsive-item"
            [src]="mediaURL"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Featured Product-->
<div *ngIf="isDataAvailable">
  <feature-products [featureProd]="loginData"></feature-products>
</div>

<!-- Templates -->

<!-- Template - Recieve a code via SMS -->
<ng-template #MFA_Authentication>
  <div *ngIf="validationStatus == 'SESSION-EXPIRED'">
    <ng-container *ngTemplateOutlet="ValidationMessage"></ng-container>
  </div>

  <div
    class="enroll-choices"
    [ngClass]="{
      show: screenType === 'EnrollMFA',
      hide: screenType != 'EnrollMFA'
    }"
  >
    <form
      data-se="o-form"
      slot="content"
      id="form63"
      class="o-form o-form-edit-mode"
    >
      <div
        data-se="o-form-content"
        class="o-form-content o-form-theme clearfix"
      >
        <h2 data-se="o-form-head" class="okta-form-title o-form-head">
          Set up multifactor authentication
        </h2>
        <p class="okta-form-subtitle o-form-explain" data-se="o-form-explain">
          <span
            >Your company requires multifactor authentication to add an
            additional layer of security when signing in to your account</span
          >
        </p>
        <div
          class="o-form-error-container"
          data-se="o-form-error-container"
        ></div>
        <div
          class="o-form-fieldset-container"
          data-se="o-form-fieldset-container"
        >
          <div class="enroll-factor-list">
            <div class="list-content">
              <div data-se="SMS" class="enroll-factor-row clearfix">
                <div class="enroll-factor-icon-container">
                  <div
                    class="factor-icon enroll-factor-icon mfa-okta-sms"
                  ></div>
                </div>
                <div class="enroll-factor-description">
                  <h3 class="enroll-factor-label">
                    Text Message to Your Phone
                  </h3>
                  <p>Enter a single-use code sent to your mobile phone.</p>
                  <div class="enroll-factor-button">
                    <button
                      data-se="button"
                      (click)="SetupMFA('EnrollSMS')"
                      class="button link-button"
                      href="#"
                    >
                      Setup
                    </button>
                  </div>
                </div>
              </div>
              <div data-se="CALL" class="enroll-factor-row clearfix">
                <div class="enroll-factor-icon-container">
                  <div
                    class="factor-icon enroll-factor-icon mfa-okta-call"
                  ></div>
                </div>
                <div class="enroll-factor-description">
                  <h3 class="enroll-factor-label">
                    Voice Call Authentication
                  </h3>
                  <p>
                    Use a phone to authenticate by following voice instructions.
                  </p>
                  <div class="enroll-factor-button">
                    <button
                      data-se="button"
                      (click)="SetupMFA('EnrollVoice')"
                      class="button link-button"
                      href="#"
                    >
                      Setup
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div
    class="enroll-sms"
    [ngClass]="{
      show: screenType != 'EnrollMFA',
      hide: screenType === 'EnrollMFA'
    }"
  >
    <div
      data-se="o-form"
      slot="content"
      id="form88"
      class="enroll-sms o-form o-form-edit-mode"
    >
      <div
        data-se="o-form-content"
        class="o-form-content o-form-theme clearfix"
      >
        <div
          class="o-form-fieldset-container"
          data-se="o-form-fieldset-container"
        >
          <div [ngSwitch]="screenType">
            <div *ngSwitchCase="'EnrollSMS'">
              <ng-container *ngTemplateOutlet="EnrollSMS"></ng-container>
            </div>
            <div *ngSwitchCase="'EnrollVoice'">
              <ng-container *ngTemplateOutlet="EnrollVoice"></ng-container>
            </div>
            <div *ngSwitchCase="'VerifySms'">
              <ng-container *ngTemplateOutlet="VerifySms"></ng-container>
            </div>
            <div *ngSwitchCase="'VerifyVoiceCall'">
              <ng-container *ngTemplateOutlet="VerifyVoiceCall"></ng-container>
            </div>

            <some-element *ngSwitchDefault></some-element>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="screenType === 'EnrollSMS' || screenType === 'EnrollVoice'"
      class="auth-footer"
    >
      <a
        href="javascript:void(0)"
        (click)="backToAuthOption()"
        class="link help js-back"
        data-se="back-link"
      >
        Back to authentication options
      </a>
    </div>
  </div>
</ng-template>

<ng-template #ValidationMessage>
  <div
    class="o-form-error-container o-form-has-errors"
    data-se="o-form-error-container"
  >
    <div *ngIf="validationStatus == 'INVALID-FORM'">
      <div class="okta-form-infobox-error infobox infobox-error" role="alert">
        <span class="icon error-16"></span>
        <p>
          We found some errors. Please review the form and make corrections.
        </p>
      </div>
    </div>

    <div *ngIf="validationStatus == 'INVALID-PHONE'">
      <div class="okta-form-infobox-error infobox infobox-error" role="alert">
        <span class="icon error-16"></span>
        <p>
          The number you entered seems invalid. If the number is correct, please
          try again.
        </p>
      </div>
    </div>

    <div *ngIf="validationStatus == 'INVALID-REQUEST'">
      <div class="okta-form-infobox-error infobox infobox-error" role="alert">
        <span class="icon error-16"></span>
        <p>
          {{ validationMessage }}
        </p>
      </div>
    </div>

    <div *ngIf="validationStatus == 'CODE-SENT'">
      <div
        class="okta-form-infobox-warning infobox infobox-warning login-timeout-warning"
      >
        <span class="icon warning-16"></span>
        <p>
          Haven't received an SMS? To try again, click
          <span style="font-weight:bold">Re-send code</span>.
        </p>
      </div>
    </div>

    <div *ngIf="validationStatus == 'REDIAL'">
      <div
        class="okta-form-infobox-warning infobox infobox-warning login-timeout-warning"
      >
        <span class="icon warning-16"></span>
        <p>
          Haven't received a voice call? To try again, click
          <span style="font-weight:bold">Redial</span>.
        </p>
      </div>
    </div>

    <div
      *ngIf="validationStatus == 'SESSION-EXPIRED'"
      class="okta-form-infobox-error infobox infobox-error"
      role="alert"
    >
      <span class="icon error-16"></span>
      <p>Your session has expired/invalid token. Please try again.</p>
    </div>
  </div>
</ng-template>
<ng-template #EnrollSMS>
  <h2 data-se="o-form-head" class="okta-form-title o-form-head">
    {{
      screenType === 'EnrollSMS'
        ? 'Receive a code via SMS to authenticate'
        : 'Text Message to Your Phone'
    }}
  </h2>

  <ng-container *ngTemplateOutlet="ValidationMessage"></ng-container>

  <p
    [ngClass]="{
      show: screenType === 'VerifySms',
      hide: screenType != 'VerifySms'
    }"
    class="okta-form-subtitle o-form-explain"
    data-se="o-form-explain"
    id="phone-display"
  >
    ({{ phoneNumber }})
  </p>
  <div class="o-form-fieldset-container">
    <form [formGroup]="smsAuthFormGroup">
      <div data-se="o-form-fieldset" class="o-form-fieldset o-form-label-top">
        <div data-se="o-form-input-container" class="o-form-input o-form-wide">
          <span
            data-se="o-form-input-countryCode"
            class="o-form-select o-form-input-name-countryCode o-form-control"
          >
            <select
              id="country"
              (change)="selectedExtension = $event.target.value"
              formControlName="country"
              class="form-control"
              [ngClass]="{
                'is-invalid': formSubmitted && formControls.country.errors
              }"
            >
              <option value="" disabled>Please Select country</option>
              <option [value]="list.extension" *ngFor="let list of countryInfo"
                >{{ list.countryName }}
              </option>
            </select>
            <!-- <p *ngIf="formSubmitted && formControls.country.invalid" id="input-container-error134"
                    class="okta-form-input-error o-form-input-error o-form-explain" role="alert">
                    <span class="icon icon-16 error-16-small" role="img"
                        aria-label="Error"></span>Please select country.
                </p> -->

            <!-- <select id="input96" name="countryCode" class="chzn-done" style="display: none;">
                    <option value="US">United States</option>
                </select>
                <div id="input96_chzn" class="chzn-container chzn-container-single"
                    style="width: 62%;" title="">
                    <a href="javascript:void(0)" class="chzn-single" tabindex="-1"><span>United
                            States</span>
                        <div><b></b></div>
                    </a>
                </div> -->
          </span>
        </div>
      </div>
      <div
        data-se="o-form-fieldset"
        class="o-form-fieldset o-form-label-top enroll-sms-phone"
      >
        <div data-se="o-form-label" class="okta-form-label o-form-label">
          <label for="input103">Phone number&nbsp;</label>
        </div>
        <div
          data-se="o-form-input-container"
          class="o-form-input o-form-input-group o-form-has-errors"
          aria-describedby="input-container-error134"
        >
          <span
            data-se="o-form-input-phoneNumber"
            class="o-form-input-name-phoneNumber okta-form-input-field o-form-has-errors"
          >
            <span class="okta-form-label-inline o-form-label-inline">{{
              selectedExtension || '--'
            }}</span>
            <span class="okta-form-input-field input-fix o-form-control">
              <input
                type="text"
                formControlName="phone"
                placeholder=""
                name="phoneNumber"
                id="input103"
                value=""
                autocomplete="off"
              />
            </span>
          </span>
          <p
            *ngIf="formSubmitted && formControls.phone.invalid"
            id="input-container-error134"
            class="okta-form-input-error o-form-input-error o-form-explain"
            role="alert"
          >
            <span
              class="icon icon-16 error-16-small"
              role="img"
              aria-label="Error"
            ></span
            >This field cannot be left blank
          </p>
        </div>
      </div>

      <button
        [disabled]="!showResendButton"
        [ngClass]="{
          'button-primary-disabled': !showResendButton,
          'button-primary': showResendButton
        }"
        data-se="sms-request-button"
        class="button js-enroll-phone margin-top-30 sms-request-button link-button"
        (click)="SendCode('CODE-SENT')"
      >
        {{ subScreenType == 'CODE-SENT' ? 'Re-' : '' }}Send code
      </button>

      <div
        class="okta-form-divider form-divider"
        *ngIf="subScreenType == 'CODE-SENT' || subScreenType == 'CODE-SEND'"
      ></div>

      <div
        data-se="o-form-fieldset"
        class="o-form-fieldset o-form-label-top"
        *ngIf="subScreenType == 'CODE-SENT' || subScreenType == 'CODE-SEND'"
      >
        <div data-se="o-form-label" class="okta-form-label o-form-label">
          <label for="input116">Enter Code&nbsp;</label>
        </div>
        <!-- <div data-se="o-form-input-container" class="o-form-input">
                <span data-se="o-form-input-passCode"
                    class="o-form-input-name-passCode o-form-control okta-form-input-field input-fix">
                    <input type="tel" formControlName="passCode" placeholder="" name="passCode"
                        id="input116" value="" aria-label="" autocomplete="off" />
                </span>
                <p id="input-container-error134"
                    class="okta-form-input-error o-form-input-error o-form-explain" role="alert">
                    <span class="icon icon-16 error-16-small" role="img" aria-label="Error"></span>This
                    field cannot be left blank
                </p>
            </div> -->

        <div
          data-se="o-form-input-container"
          class="o-form-input o-form-input-group o-form-has-errors"
          aria-describedby="input-container-error134"
        >
          <span
            data-se="o-form-input-passCode"
            class="o-form-input-name-passCode okta-form-input-field o-form-has-errors"
          >
            <span class="okta-form-input-field input-fix o-form-control">
              <input
                type="text"
                formControlName="passCode"
                placeholder="Enter Code"
                name="passCode"
                id="input103"
                value=""
                autocomplete="off"
              />
            </span>
          </span>
          <p
            *ngIf="formSubmitted && formControls.passCode.invalid"
            id="input-container-error134"
            class="okta-form-input-error o-form-input-error o-form-explain"
            role="alert"
          >
            <span
              class="icon icon-16 error-16-small"
              role="img"
              aria-label="Error"
            ></span
            >This field cannot be left blank
          </p>
        </div>
        <div class="custom-checkbox"></div>
        <br />
        <div class="o-form-button-bar">
          <button
            class="button button-primary"
            (click)="Verify()"
            data-type="save"
          >
            Verify
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #EnrollVoice>
  <h2 data-se="o-form-head" class="okta-form-title o-form-head">
    FOLLOW PHONE CALL INSTRUCTIONS TO AUTHENTICATE
  </h2>
  <ng-container *ngTemplateOutlet="ValidationMessage"></ng-container>
  <div class="o-form-fieldset-container">
    <form [formGroup]="smsAuthFormGroup">
      <div data-se="o-form-fieldset" class="o-form-fieldset o-form-label-top">
        <div data-se="o-form-input-container" class="o-form-input o-form-wide">
          <span
            data-se="o-form-input-countryCode"
            class="o-form-select o-form-input-name-countryCode o-form-control"
          >
            <select
              id="country"
              (change)="selectedExtension = $event.target.value"
              formControlName="country"
              class="form-control"
              [ngClass]="{
                'is-invalid': formSubmitted && formControls.country.errors
              }"
            >
              <option value="" disabled>Please Select country</option>
              <option [value]="list.extension" *ngFor="let list of countryInfo"
                >{{ list.countryName }}
              </option>
            </select>
          </span>
        </div>
      </div>
      <div
        data-se="o-form-fieldset"
        class="o-form-fieldset o-form-label-top enroll-sms-phone"
      >
        <div data-se="o-form-label" class="okta-form-label o-form-label">
          <label for="input103">Phone number&nbsp;</label>
        </div>
        <div
          data-se="o-form-input-container"
          class="o-form-input o-form-input-group o-form-has-errors"
          aria-describedby="input-container-error134"
        >
          <span
            data-se="o-form-input-phoneNumber"
            class="o-form-input-name-phoneNumber okta-form-input-field o-form-has-errors"
          >
            <span class="okta-form-label-inline o-form-label-inline">{{
              selectedExtension || '--'
            }}</span>
            <span class="okta-form-input-field input-fix o-form-control">
              <input
                type="text"
                formControlName="phone"
                placeholder=""
                name="phoneNumber"
                id="input103"
                value=""
                autocomplete="off"
              />
            </span>
          </span>
          <p
            *ngIf="formSubmitted && formControls.phone.invalid"
            id="input-container-error134"
            class="okta-form-input-error o-form-input-error o-form-explain"
            role="alert"
          >
            <span
              class="icon icon-16 error-16-small"
              role="img"
              aria-label="Error"
            ></span
            >This field cannot be left blank
          </p>
        </div>
      </div>

      <button
        [disabled]="!showResendButton"
        [ngClass]="{
          'button-primary-disabled': !showResendButton,
          'button-primary': showResendButton
        }"
        data-se="sms-request-button"
        class="button js-enroll-phone margin-top-30 sms-request-button link-button"
        (click)="SendCode('CALLING')"
      >
        {{ subScreenType }}
      </button>

      <div class="okta-form-divider form-divider"></div>

      <div
        data-se="o-form-fieldset"
        class="o-form-fieldset o-form-label-top"
        *ngIf="subScreenType == 'REDIAL'"
      >
        <div data-se="o-form-label" class="okta-form-label o-form-label">
          <label for="input116">Enter Code&nbsp;</label>
        </div>

        <div
          data-se="o-form-input-container"
          class="o-form-input o-form-input-group o-form-has-errors"
          aria-describedby="input-container-error134"
        >
          <span
            data-se="o-form-input-passCode"
            class="o-form-input-name-passCode okta-form-input-field o-form-has-errors"
          >
            <span class="okta-form-input-field input-fix o-form-control">
              <input
                type="text"
                formControlName="passCode"
                placeholder="Enter Code"
                name="passCode"
                id="input103"
                value=""
                autocomplete="off"
              />
            </span>
          </span>
          <p
            *ngIf="formSubmitted && formControls.passCode.invalid"
            id="input-container-error134"
            class="okta-form-input-error o-form-input-error o-form-explain"
            role="alert"
          >
            <span
              class="icon icon-16 error-16-small"
              role="img"
              aria-label="Error"
            ></span
            >This field cannot be left blank
          </p>
        </div>
        <div class="custom-checkbox"></div>
        <br />
        <div class="o-form-button-bar">
          <button
            class="button button-primary"
            (click)="Verify()"
            data-type="save"
          >
            Verify
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #VerifySms>
  <h2 data-se="o-form-head" class="okta-form-title o-form-head">
    {{
      screenType === 'EnrollSMS'
        ? 'Receive a code via SMS to authenticate'
        : 'Text Message to Your Phone'
    }}
  </h2>
  <ng-container *ngTemplateOutlet="ValidationMessage"></ng-container>
  <p
    [ngClass]="{
      show: screenType === 'VerifySms',
      hide: screenType != 'VerifySms'
    }"
    class="okta-form-subtitle o-form-explain"
    data-se="o-form-explain"
    id="phone-display"
  >
    ({{ phoneNumber }})
  </p>
  <form [formGroup]="smsAuthFormGroup">
    <div class="o-form-fieldset-container" data-se="o-form-fieldset-container">
      <button
        [disabled]="!showResendButton"
        [ngClass]="{
          'button-primary-disabled': !showResendButton,
          'button-primary': showResendButton
        }"
        data-se="sms-request-button link-button"
        class="button js-enroll-phone margin-top-30 sms-request-button link-button"
        (click)="SendCode('CODE-SENT')"
      >
        {{ subScreenType == 'CODE-SENT' ? 'Re-' : '' }}Send code
      </button>

      <div class="okta-form-divider form-divider"></div>
      <div data-se="o-form-fieldset" class="o-form-fieldset o-form-label-top">
        <div data-se="o-form-label" class="okta-form-label o-form-label">
          <label for="input116">Enter Code&nbsp;</label>
        </div>

        <div
          data-se="o-form-input-container"
          class="o-form-input o-form-input-group o-form-has-errors"
          aria-describedby="input-container-error134"
        >
          <span
            data-se="o-form-input-passCode"
            class="o-form-input-name-passCode okta-form-input-field o-form-has-errors"
          >
            <span class="okta-form-input-field input-fix o-form-control">
              <input
                type="text"
                formControlName="passCode"
                placeholder="Enter Code"
                name="passCode"
                id="input103"
                value=""
                autocomplete="off"
              />
            </span>
          </span>
          <p
            *ngIf="formSubmitted && formControls.passCode.invalid"
            id="input-container-error134"
            class="okta-form-input-error o-form-input-error o-form-explain"
            role="alert"
          >
            <span
              class="icon icon-16 error-16-small"
              role="img"
              aria-label="Error"
            ></span
            >This field cannot be left blank
          </p>
        </div>
        <div class="custom-checkbox">
          <input
            type="checkbox"
            formControlName="rememberDevice"
            name="rememberDeviceSms"
            id="rememberDeviceSms"
            [value]="remeberDevice"
            (change)="checkedRemeberDevice()"
          />
          <label
            for="rememberDeviceSms"
            data-se-for-name="rememberDeviceSms"
            [ngClass]="{ checked: remeberDevice }"
            id="rememberDeviceSmsLabel"
            >Do not challenge me on this device again</label
          >
        </div>
      </div>
    </div>
    <div class="o-form-button-bar">
      <button class="button button-primary" (click)="Verify()" data-type="save">
        Verify
      </button>
    </div>
  </form>
</ng-template>

<ng-template #VerifyVoiceCall>
  <h2 data-se="o-form-head" class="okta-form-title o-form-head">
    FOLLOW PHONE CALL INSTRUCTIONS TO AUTHENTICATE
  </h2>
  <ng-container *ngTemplateOutlet="ValidationMessage"></ng-container>
  <p
    [ngClass]="{
      show: screenType === 'VerifyVoiceCall',
      hide: screenType != 'VerifyVoiceCall'
    }"
    class="okta-form-subtitle o-form-explain"
    data-se="o-form-explain"
    id="phone-display"
  >
    ({{ phoneNumber }})
  </p>
  <form [formGroup]="smsAuthFormGroup">
    <div class="o-form-fieldset-container" data-se="o-form-fieldset-container">
      <button
        [disabled]="!showResendButton"
        [ngClass]="{
          'button-primary-disabled': !showResendButton,
          'button-primary': showResendButton
        }"
        data-se="sms-request-button link-button"
        class="button js-enroll-phone margin-top-30 sms-request-button link-button"
        (click)="SendCode('CALLING')"
      >
        {{ subScreenType }}
      </button>

      <div class="okta-form-divider form-divider"></div>
      <div data-se="o-form-fieldset" class="o-form-fieldset o-form-label-top">
        <div data-se="o-form-label" class="okta-form-label o-form-label">
          <label for="input116">Enter Code&nbsp;</label>
        </div>

        <div
          data-se="o-form-input-container"
          class="o-form-input o-form-input-group o-form-has-errors"
          aria-describedby="input-container-error134"
        >
          <span
            data-se="o-form-input-passCode"
            class="o-form-input-name-passCode okta-form-input-field o-form-has-errors"
          >
            <span class="okta-form-input-field input-fix o-form-control">
              <input
                type="text"
                formControlName="passCode"
                placeholder="Enter Code"
                name="passCode"
                id="input103"
                value=""
                autocomplete="off"
              />
            </span>
          </span>
          <p
            *ngIf="formSubmitted && formControls.passCode.invalid"
            id="input-container-error134"
            class="okta-form-input-error o-form-input-error o-form-explain"
            role="alert"
          >
            <span
              class="icon icon-16 error-16-small"
              role="img"
              aria-label="Error"
            ></span
            >This field cannot be left blank
          </p>
        </div>
        <div class="custom-checkbox">
          <input
            type="checkbox"
            formControlName="rememberDevice"
            name="rememberDeviceSms"
            id="rememberDeviceSms"
            [value]="remeberDevice"
            (change)="checkedRemeberDevice()"
          />
          <label
            for="rememberDeviceSms"
            data-se-for-name="rememberDeviceSms"
            [ngClass]="{ checked: remeberDevice }"
            id="rememberDeviceSmsLabel"
            >Do not challenge me on this device again</label
          >
        </div>
      </div>
    </div>
    <div class="o-form-button-bar">
      <button class="button button-primary" (click)="Verify()" data-type="save">
        Verify
      </button>
    </div>
  </form>
</ng-template>
